/**
 * caminhoSeguroDoPortal — PR 4 Task 5, fix round 1.
 *
 * Normaliza e valida um `link` vindo do backend (notificação do sininho,
 * `NotificacaoDoPortal.link`) antes de navegar. Defesa em profundidade: o
 * backend já monta `link` a partir de uma lista fechada
 * (`link_da_notificacao`), mas um cheque ingênuo tipo
 * `link.startsWith("/portal/")` é insuficiente —
 * `"/portal/../login".startsWith("/portal/")` também é `true`, e o React
 * Router resolve o `..` e navegaria pra `/login`, fora do portal.
 *
 * `new URL(link, window.location.origin)` resolve dot-segments e host
 * relativo (`//host/...`) ANTES de qualquer comparação — o `pathname` que
 * sobra já vem limpo. Dali exigimos:
 * 1. mesma origem (protocolo + host) da página atual — barra `//evil.com/...`,
 *    `https://evil.com/portal/...` e esquemas como `javascript:` (origem
 *    `"null"` nesses casos, nunca igual à da página);
 * 2. `pathname` começando literalmente com `/portal/` (com a barra — `/portalx`
 *    não conta).
 *
 * Devolve `pathname + search + hash` (o suficiente pra `navigate()`), ou
 * `null` se qualquer checagem falhar — o chamador trata como "sem link".
 *
 * Nome e assinatura estáveis de propósito: o PR 5 (página de entrada do
 * portal) reusa esta mesma função.
 */
export function caminhoSeguroDoPortal(link?: string | null): string | null {
  if (!link) return null;

  let url: URL;
  try {
    url = new URL(link, window.location.origin);
  } catch {
    return null;
  }

  if (url.origin !== window.location.origin) return null;
  if (!url.pathname.startsWith("/portal/")) return null;

  return `${url.pathname}${url.search}${url.hash}`;
}
